import type { Decision, StatusResponse } from "../../api/types";
import { texte } from "../../texte";

export function RawStatus({ status, decisions }: { status: StatusResponse; decisions: Decision[] }) {
  const view = {
    code: status.code,
    budget: status.budget,
    run: status.run ?? null,
    open_decisions: decisions.filter((d) => !d.answer).map((d) => d.qid),
  };
  return (
    <>
      <p className="hint" style={{ marginBottom: 10 }}>
        {texte.rawStatus.hint}
      </p>
      <div className="logbox">{JSON.stringify(view, null, 2)}</div>
    </>
  );
}
